import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import {Button, LoadingIndicator} from '../../../components'
import {Container, Title, Subtitle, Link, Selector, Calendar, SimpleSelector} from '../../flow'
import moment from '../../../common/moment'
import {formatAddress} from '../../../common/format'

const styles = (theme) => ({
  container: {maxWidth: 328, margin: '0 auto'},
  subTitle: {marginBottom: 20},
  link: {textAlign: 'right', marginTop: 10, marginBottom: 30},
  simpleSelector: {margin: '15px 0'},
  button: {margin: '5px 0'},
})

class CalendarStep extends React.Component {

  static displayName = 'CalendarStep.component'

  state = {
    openAddress: false,
    timeslotStartError: false,
    timeslotEndError: false,
  }

  setOpenAddress = (open) => this.setState({openAddress: open})

  onSelectAddress = (id) => {
    this.setOpenAddress(false)
    this.props.selectAddress(id)
  }

  onSelectTimeslot = (id, type) => {
    this.setState({
      timeslotStartError: false,
      timeslotEndError: false,
    })
    this.props.selectTimeslot(id, type)
  }

  onContinue = () => {
    if (this.props.timeslotStartSelected === 0) {
      this.setState({timeslotStartError: true})
    } else if (this.props.timeslotEndSelected === 0) {
      this.setState({timeslotEndError: true})
    } else {
      this.props.continue()
    }
  }

  render() {
    const {classes} = this.props
    return (
      <Container className={classes.container}>
        <Title>¡Perfecto! Ya puedes iniciar el alquiler</Title>
        {this.props.dateStartSelected === null || this.props.timeslotsStart.length === 0
          ? <Subtitle className={classes.subTitle}>Indicanos cuándo quieres recibir este artículo</Subtitle>
          : <Subtitle className={classes.subTitle}>Indicanos cuándo quieres devolver este artículo</Subtitle>
        }
        <Selector
          defaultLabel={'No hay dirección seleccionada'}
          title={'Dirección de entrega y retiro'}
          open={this.state.openAddress}
          onClose={() => this.setOpenAddress(false)}
          onOpen={() => this.setOpenAddress(true)}
          onCancel={() => this.setOpenAddress(false)}
          onSelect={this.onSelectAddress}
          options={this.props.addresses.map(a => ({
            label: formatAddress(a.Address, a.Number, a.Floor, a.Apartment, ''),
            value: a.ID,
            disabled: a.InDeliveryRange === false,
          }))}
          value={this.props.addressSelected}
          isLoading={this.props.isAddressLoading}
        />
        <div className={classes.link}>
          <Link onClick={this.props.goToAddress}>Crear nueva dirección</Link>
        </div>
        <Calendar
          mode={'range'}
          disabledDates={this.props.unavailableDates}
          minDate={moment().add(-1, 'day')}
          maxDate={moment().add(90, 'day')}
          onClick={(start, end) => this.props.selectDates(start, end)}
          isLoading={this.props.isCalendarLoading}
        />
        <div style={{margin: '30px 0'}}>
          <SimpleSelector
            title={'Seleccionar horario de recepción'}
            className={classes.simpleSelector}
            value={this.props.timeslotStartSelected}
            onSelect={(id) => this.onSelectTimeslot(id, 'start')}
            options={this.props.timeslotsStart.map(t => ({
              label: t.get('Hour') + ':' + pad(t.get('Minute')),
              value: t.get('ID'),
              disabled: false,
            }))}
            disabled={this.props.dateStartSelected === null || this.props.timeslotsStart.length === 0}
            isLoading={this.props.isTimeSlotLoading}
            error={this.state.timeslotStartError}
          />
          <SimpleSelector
            title={'Seleccionar horario de retiro'}
            className={classes.simpleSelector}
            value={this.props.timeslotEndSelected}
            onSelect={(id) => this.onSelectTimeslot(id, 'end')}
            options={this.props.timeslotsEnd.map(t => ({
              label: t.get('Hour') + ':' + pad(t.get('Minute')),
              value: t.get('ID'),
              disabled: false,
            }))}
            disabled={this.props.dateStartSelected === null || this.props.timeslotsEnd.length === 0 || this.props.timeslotStartSelected === 0}
            isLoading={this.props.isTimeSlotLoading}
            error={this.state.timeslotEndError}
          />
        </div>
        <LoadingIndicator show={this.props.isButtonLoading}>
          <Button
            variant={'primary'}
            fullWidth={true}
            className={classes.button}
            onClick={this.onContinue}
            disabled={this.props.isButtonDisabled}
          >
            Continuar
          </Button>
        </LoadingIndicator>
      </Container>
    )
  }

  static propTypes = {
    dateStartSelected: PropTypes.object,
    dateEndSelected: PropTypes.object,
    unavailableDates: PropTypes.array,
    timeslotsStart: PropTypes.array,
    timeslotsEnd: PropTypes.array,
    timeslotStartSelected: PropTypes.number,
    timeslotEndSelected: PropTypes.number,
    selectDates: PropTypes.func.isRequired,
    selectTimeslot: PropTypes.func.isRequired,
    setStep: PropTypes.func.isRequired,
    isCalendarLoading: PropTypes.bool,
    isTimeSlotLoading: PropTypes.bool,
    isAddressLoading: PropTypes.bool,
    error: PropTypes.string,
    selectAddress: PropTypes.func.isRequired,
    addressSelected: PropTypes.number,
    addresses: PropTypes.array,
    continue: PropTypes.func,
    isButtonLoading: PropTypes.bool,
    isButtonDisabled: PropTypes.bool,
    goToAddress: PropTypes.func.isRequired,
  }
}

export default withStyles(styles, {withTheme: true})(CalendarStep)

function pad(string) {
  const str = '' + string
  const pad = '00'
  return pad.substring(0, pad.length - str.length) + str
}



// WEBPACK FOOTER //
// ./src/sections/rentV2/components/calendar.step.jsx